import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  TextField,
  EditButton,
  DateField,
  Resource,
  Filter,
  Show,
  Datagrid,
} from "react-admin";


const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="iso_code" alwaysOn />
    <TextInput label="Category" source="category" />
  </Filter>
);

const Iso3758CareCodesList = (props) => {
  return (
    <List {...props} filters={Filters(props)}>
      <div style={{ marginTop: '15px' }}>
        <Datagrid rowClick="show">
          <TextField source="iso_code" label="ISO code" />
          <TextField source="category" label="Category" />
          <TextField source="description" label="Description" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowIso3758CareCodes = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="id" label="ID" />
        <TextField source="iso_code" label="ISO code" />
        <TextField source="category" label="Category" />
        <TextField source="description" label="Description" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateIso3758CareCodes = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="iso_code" label="ISO code" required={true} />
        <TextInput source="category" label="Category" required={true} />
        <TextInput source="description" label="Description" required={true} />
      </SimpleForm>
    </Create>
  );
};

const EditIso3758CareCodes = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        {/* iso_code es de solo lectura en edición: el backend tiene unicidad en DB.
            category y description sí son editables. */}
        <TextInput source="iso_code" label="ISO code" disabled />
        <TextInput source="category" label="Category" required={true} />
        <TextInput source="description" label="Description" required={true} />
      </SimpleForm>
    </Edit>
  );
};


const iso3758CareCodesResource = () => <Resource
  name="iso3758CareCodes"
  options={{ label: 'Care instructions', menuGroup: 'Bcome' }}
  list={Iso3758CareCodesList}
  create={CreateIso3758CareCodes}
  edit={EditIso3758CareCodes}
  show={ShowIso3758CareCodes} />;

export default iso3758CareCodesResource;
